export default __webpack_public_path__ + "static/media/310.40ea5dc8.png";